import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Table, Card, CardBody } from "reactstrap"
import { SuccessOk } from "configs/statusCode"
import CardItem from "./CardItem"
import { adminPrefix } from "configs/routePrefix"
import Paginator from "components/Common/Paginator/Paginator"
import PaymentPlanService from "services/Admin/PaymentPlanService"
import FilterModal from "./FilterModal"
import FilterIcon from "assets/images/filter.png"
import "./styles.scss"
import { useDispatch, useSelector } from "react-redux"
import { appendFilters } from "store/adminFilter/actions"

const PaymentPlan = (props) => {
  const id = props?.match?.params?.id
  const AuthData = useSelector(state => state.Auth)
  const filter = useSelector(state => state.adminFilter)
  const dispatch = useDispatch()
  const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
  const [filtersParams, setFilterParams] = useState(null)
  const [shouldGetData, setShouldGetData] = useState(false)
  const paymentPlanService = new PaymentPlanService()
  const [active, setActive] = useState("all")
  const [searchWord, setSearchWord] = useState("")
  const [list, setList] = useState([])
  const [modal, setModal] = useState(false)
  const [noData, setNoData] = useState(false)
  const compound_id = filter?.compound_id || localStorage.getItem('compound_id')

  const [filterData, setFilterData] = useState({
    compound_ids:null
  })
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: 1,
  })

  const toggle = () => setModal(!modal)

  const updateHandler = (id) => {
    props.history.push(`${adminPrefix}/payment-plan/create-payment/${id}`)
  }

  const OnSearchChange = (e) => {
    const search = e.target.value
    setSearchWord(search)
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const params = {}
      if (active != 'all') params['status'] = active === "active" ? 1 : 0
      if (searchWord.trim().length) params['keyword'] = searchWord
      if (filter.path == 'fromCompound'){
        params["compound_ids"] = compound_id
      }
      setFilterParams({ ...params })
    }, 1000)

    return () => clearTimeout(timeoutId)
  }, [active, searchWord, filterData.compound_ids])

  useEffect(()=>{
    if(!!filter?.compound_id && !!id){
      setFilterData({compound_ids: [{value: filter.compound_id}]})
    }

    // return ()=> dispatch(appendFilters({compound_id: null}))
  },[])

  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Payment plan</title>
        </MetaTags>
        <Container fluid>
          <Row className="mb-1">
            <Col md={6}>
              <div className="d-flex mb-2">
                  <button className="p-0 m-0 border-0 me-2"
                  style={{background: 'none'}}
                      onClick={() => {
                          //props.history.location.pathname
                          props.history?.push(`${adminPrefix}/Admin-developer/cards/${compound_id}`)
                      }}>
                      <i className="fa fa-arrow-left text-success me-2 font-size-16"></i>
                  </button>
                  <h4 className="m-0">Manage Payment Plans</h4>
              </div>
              <p>You can manage All Payment Plans in the Selected Compound</p>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={searchWord}
                  onChange={(e) => OnSearchChange(e)}
                  placeholder="Search by payment plan name, I.D" />
              </div>
            </Col>
              {isExist("payment.add") ? <Col md={6}>
              <div className="d-md-flex justify-content-md-end mb-2">
                <button
                  className="btn btn-success btnHeight px-lg-4"
                  onClick={()=> props.history.push(`${adminPrefix}/payment-plan/create-payment`)}
                >
                  Add Payment Plan
                </button> 
              </div>
            </Col>:null}
          </Row>
          <Row className="mb-4" >
            <Col md={6} sm={8} className="mb-3">
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "all" ? "#556ee6" : "#f4f4f4",
                  color: active == "all" ? "#FFF" : "#495057"
                }}
                onClick={() => setActive("all")}
              >
                All
                </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "active" ? "#556ee6" : "#f4f4f4",
                  color: active == "active" ? "#FFF" : "#495057"
                }}
                onClick={() => setActive("active")}
              >
                Active
              </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                  color: active == "deactive" ? "#FFF" : "#495057"
                }}
                onClick={() => setActive("deactive")}
              >
                Deactive
              </button>
            </Col>
            {!filter.compound_id && <Col md={6} sm={4} className="mb-3 d-flex flex-row-reverse">
              <button
                className="btn btnUpload btnHeight px-4 " onClick={toggle}
              ><img src={FilterIcon} style={{ marginRight: "5px" }} />
                Filter
              </button>
            </Col>}
          </Row>
          <div>
            <Card className="w-100 mt-4">
              <CardBody>
                <div className='py-3'>
                  <div>
                    <div className="table-responsive position-relative">
                      <Table>
                        <thead>
                          <tr className='bgHeaderTable'>
                            <th className='font-size-14'>I.D</th>
                            <th className='font-size-14'>Payment Plan Name</th>
                            <th className='font-size-14'>Compound Name</th>
                            <th className='font-size-14'>Status</th>
                            <th className='font-size-14'></th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.map((item, index) => <CardItem
                            key={index}
                            index={index}
                            {...item}
                            item={item}
                            Service={PaymentPlanService}
                            updateHandler={() => updateHandler(item.id)}
                            setShouldGetData={setShouldGetData}
                          />)}
                        </tbody>
                      </Table>
                      {(noData && !!filter?.developer_id) && <b style={{
                          left: '50%',
                          position: 'absolute',
                          transform: 'translate(-50%, 15px)'
                      }}>
                          There's no payment plan in the selected compound 
                      </b>}
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Row className="d-flex justify-content-end">
              <Col className="d-flex justify-content-end" md={8} sm={12}>
                <Paginator
                  service={paymentPlanService}
                  pageOptions={pageOptions}
                  setData={(data) => {
                    setList([...data])
                    if(data?.length > 0){
                      setNoData(false)
                    } else{
                        setNoData(true)
                    }
                  }}
                  setPageOptions={setPageOptions}
                  filtersParams={filtersParams}
                  shouldGetData={shouldGetData}
                  setShouldGetData={setShouldGetData}
                />
              </Col>
            </Row >
            {modal ? <FilterModal
              toggle={toggle}
              modal={modal}
              onSumbit={(data) => setFilterData(data)}
              filterData={filterData}
            /> : null}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PaymentPlan